export const MARGIN = 10
export const PADDING = 10

export const RADIUS = 10
